import React from 'react'
import './coalition-drop.css'
export default function CoalitionDrop() {
  return (
    <div className='coalition-container'>
        <div className="location-details">
            <p className="main-location">
                Don McGill Toyota
            </p>
            <p className="sub-location">
                11800 Katy Freeway
            </p>
            <p className="sub-location">
                Houston TX 77079
            </p>
        </div>
        <table>
            <thead>
                <tr>
                    <th>Days</th>
                    <th>Time</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Monday</td>
                    <td>9AM - 7PM</td>
                </tr>
                <tr>
                    <td>Tuesday</td>
                    <td>9AM - 7PM</td>
                </tr>
                <tr>
                    <td>Wednesday</td>
                    <td>9AM - 7PM</td>
                </tr>
                <tr>
                    <td>Thursday</td>
                    <td>9AM - 7PM</td>
                </tr>
                <tr>
                    <td>Friday</td>
                    <td>9AM - 7PM</td>
                </tr>
                <tr>
                    <td>Saturday</td>
                    <td>10AM - 5PM</td>
                </tr>
                <tr>
                    <td>Sunday</td>
                    <td>Closed</td>
                </tr>
            </tbody>
        </table>
    </div>
  )
}
